import { Label, Error, Icon, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';

interface TextInputProps {
  name: string;
  id?: string;
  label?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  className?: string;
  errorMessage?: string;
  autoComplete?: string;
  required?: boolean;
  disabled?: boolean;
  valid?: boolean;
  warning?: boolean;
  rows?: number;
  maxLength?: number;
  width?: React.CSSProperties['width'];
  inputStyle?: React.CSSProperties;
  validateOnBlur?: boolean;
  onChange?: (name: string, value: string, valid: boolean | undefined) => void;
}

export function TextInput(props: TextInputProps) {
  const error = props.errorMessage || 'Please enter a value';
  const autoComplete = props.autoComplete ?? 'off';

  function validate(e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) {
    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '') valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '') valid = true;

    if (props.required && value !== '') valid = true;

    // update the parent form
    props.onChange?.(props.name, value, valid);
  }

  // style
  const textStyle = ClassHelper(Style, {
    textbox: true,
    textarea: props.type === 'textarea',
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,
  });

  return (
    <div
      className={Style.input}
      // it was added by Huseyin
      style={{ width: props.width }}
    >
      {props.label && <Label text={props.label} required={props.required} for={props.name} />}

      {props.type === 'textarea' ? (
        <textarea
          id={props.id}
          name={props.name}
          value={props.value}
          rows={props.rows}
          className={textStyle}
          style={props.inputStyle}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          autoComplete={autoComplete}
          onChange={(e) => props.onChange?.(props.name, e.target.value, undefined)}
          onBlur={props.validateOnBlur === false ? undefined : (e) => validate(e)}
        ></textarea>
      ) : (
        <input
          type="text"
          id={props.name}
          name={props.name}
          value={props.value || ''}
          className={textStyle}
          style={props.inputStyle}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          autoComplete={autoComplete}
          onChange={(e) => props.onChange?.(props.name, e.target.value, undefined)}
          onBlur={props.validateOnBlur === false ? undefined : (e) => validate(e)}
          disabled={props.disabled}
        />
      )}

      {props.valid === false && <Error message={error} />}

      {props.valid === true && <Icon image="check" color="#8CC57D" className={Style.successIcon} size={16} />}
    </div>
  );
}
